module.exports = __webpack_public_path__ + "static/media/confirmation_lifestyle_desktop.6b25384b.webp";